import React, { useCallback, useEffect, useMemo } from 'react';
import Input from '../utils/Input';
import Switch from '../utils/Switch';
import DateInput from '../utils/DateInput';
import Select from 'react-select';
import { deliveryType, promotionType } from './constants';
import { isNumber } from 'lodash';
import { sourcesPromo, sourcesTitlePromo } from '../../constants/app';
import moment from 'moment';

const AddForm = (props) => {
    const { add: values, setAddPromotion, addPromotion, fetchPromotions, loadingCity, cities, loadingGoods, goods, categories } = props;

    useEffect(() => {
        return () => setAddPromotion(null)
    }, [setAddPromotion]);

    const cancelAdd = () => {
        setAddPromotion(null);
    }

    const addPromotionHandler = async () => {
        const data = { ...values };
        data.startDate = data.startDate ? `${moment(data.startDate).format('YYYY-MM-DDTHH:mm:ss')}.000Z` : null;
        data.endDate = data.endDate ? `${moment(data.endDate).format('YYYY-MM-DDTHH:mm:ss')}.000Z` : null;
        data.startTimeDate = data.startTimeDate ? `${moment(data.startTimeDate).format('YYYY-MM-DDTHH:mm:ss')}.000Z` : null;
        data.endTimeDate = data.endTimeDate ? `${moment(data.endTimeDate).format('YYYY-MM-DDTHH:mm:ss')}.000Z` : null;
        const result = await addPromotion(data);
        if (result) {
            fetchPromotions('marketing');
            setAddPromotion(null);
        }
    }

    const onChangeAdd = useCallback((field, value) => {
        const updated = {
            ...values,
            [field]: value
        };

        if (field === 'cities' && !value) {
            updated.cities = [];
        }

        if (field === 'type') {
            updated.persent = 0;
            updated.goods = [];
            updated.category = [];
            updated.value = null;
        }

        setAddPromotion(updated);
    }, [setAddPromotion, values]);

    const onChangeGoods = useCallback((selected) => {
        const data = selected ? selected.map(item => {
            if (item.sale === null || item.sale === undefined) {
                return { ...item, sale: null, persent: 0 };
            }
            return item;
        }) : []
        onChangeAdd('goods', data);
    }, [onChangeAdd]);

    const onChangeGoodsItem = useCallback((field, index, value) => {
        const goods = [...values.goods];
        goods[index][field] = value
        onChangeAdd('goods', goods);
    }, [onChangeAdd, values.goods]);

    const onChangeSource = useCallback(() => (value) => {
        onChangeAdd('sources', value ? value.join(' ') : '');
    }, [onChangeAdd]);

    const isValidAdd = useMemo(() => {
        if (!values.name || !values.minPrice) {
            return false
        }

        if (values.type === 'order' || values.type === 'category') {
            if (!values.value) return false;
        }

        if (values.type === 'goods') {
            if (!values.goods || values.goods.length === 0) return false;
            if (values.goods.some(item => !item.sale)) return false;
        }

        if (values.type === 'addGoods') {
            if (!values.goods || values.goods.length === 0) return false;
            if (values.goods.some(item => !isNumber(item.sale))) return false;
            if (values.goods.some(item => !item.article)) return false;
        }

        if (values.type === 'category') {
            if (!values.category) return false;
        }

        if ((values.startTimeDate && !values.endTimeDate) || (!values.startTimeDate && values.endTimeDate)) {
            return false;
        }

        return true;
    }, [values.category, values.endTimeDate, values.goods, values.minPrice, values.name, values.startTimeDate, values.type, values.value]);

    const footer = useMemo(() => {
        return (
            <div className="kt-form__actions">
                <button onClick={cancelAdd} style={{ marginRight: 10 }} className="btn btn-secondary btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u">
                    Отмена
                </button>
                <button onClick={addPromotionHandler} disabled={!isValidAdd} className="btn btn-success btn-md btn-tall btn-wide kt-font-bold kt-font-transform-u">
                    Сохранить
                </button>
            </div>
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancelAdd, isValidAdd])

    const namesCodeBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Название*</label>
                <div className="col-lg-9 col-xl-9">
                    <Input onChange={(e) => onChangeAdd('name', e.target.value)} disableGroup={true} value={values.name}/>
                </div>
            </div>
        );
    }, [onChangeAdd, values.name]);

    const cityBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Город</label>
                <div className="col-lg-9 col-xl-9">
                    <Select
                        isLoading={loadingCity}
                        isDisabled={loadingCity}
                        isMulti
                        menuPortalTarget={document.body}
                        closeMenuOnSelect={true}
                        value={values.cities ? values.cities.map(item => ({
                            value: item.id || item.value,
                            label: item.name || item.label
                        })) : []}
                        onChange={(selected) => onChangeAdd('cities', selected)}
                        options={
                            cities.map(item => ({
                                value: item.id,
                                label: item.name
                            }))
                        }
                        placeholder="Любой"
                        noOptionsMessage={() => 'Нет городов'}
                    />
                </div>
            </div>
        );
    }, [cities, loadingCity, onChangeAdd, values.cities]);

    const variantGoods = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Список товаров</label>
                <div className="col-lg-9 col-xl-9">
                    <Select
                        isLoading={loadingGoods}
                        isDisabled={loadingGoods}
                        menuPortalTarget={document.body}
                        isMulti
                        isSearchable
                        closeMenuOnSelect={true}
                        options={goods}
                        placeholder="Товары"
                        noOptionsMessage={() => 'Нет товаров'}
                        onChange={onChangeGoods}
                        value={values.goods}
                    />

                    {
                        values.goods && values.goods.length > 0 && (
                            <div style={{ marginTop: 15 }}>
                                {
                                    values.goods.map((good, index) => (
                                        <div style={{ marginTop: 5, alignItems: 'center' }} className="row">
                                            <div className="col-xl-3 col-lg-3">{good.label}</div>
                                            <div className="col-lg-4 col-xl-4">
                                                <Input placeholder="Скидка" onChange={(e) => onChangeGoodsItem('sale', index , e.target.value ? +e.target.value : null)} type="number" disableGroup={true} value={good.sale}/>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }} className="col-lg-4 col-xl-4">  
                                                <Switch nomargin={true} onChange={(value) => onChangeGoodsItem('persent', index, +value)} checked={!!good.persent}/>
                                                <div style={{ marginLeft: 10 }}>Процент</div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }, [goods, loadingGoods, onChangeGoods, onChangeGoodsItem, values.goods]);

    const variantAddGoods = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Список товаров</label>
                <div className="col-lg-9 col-xl-9">
                    <Select
                        isLoading={loadingGoods}
                        isDisabled={loadingGoods}
                        menuPortalTarget={document.body}
                        isMulti
                        isSearchable
                        closeMenuOnSelect={true}
                        options={goods}
                        placeholder="Товары"
                        noOptionsMessage={() => 'Нет товаров'}
                        onChange={onChangeGoods}
                        value={values.goods}
                    />

                    {
                        values.goods && values.goods.length > 0 && (
                            <div style={{ marginTop: 15 }}>
                                {
                                    values.goods.map((good, index) => (
                                        <div style={{ marginTop: 5, alignItems: 'center' }} className="row">
                                            <div className="col-xl-3 col-lg-3">{good.label}</div>
                                            <div className="col-lg-4 col-xl-4">
                                                <Input placeholder="Цена" onChange={(e) => onChangeGoodsItem('sale', index , e.target.value ? +e.target.value : null)} type="number" disableGroup={true} value={good.sale}/>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }} className="col-lg-4 col-xl-4">
                                                <Input placeholder="Артикул" onChange={(e) => onChangeGoodsItem('article', index, e.target.value)} disableGroup={true} value={good.article}/>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }, [goods, loadingGoods, onChangeGoods, onChangeGoodsItem, values.goods]);

    const variantCategoryBlock = useMemo(() => {
        return (
            <>
                 <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Категория</label>
                    <div className="col-lg-9 col-xl-9">
                        <Select
                            isLoading={loadingGoods}
                            isDisabled={loadingGoods}
                            menuPortalTarget={document.body}
                            isSearchable
                            closeMenuOnSelect={true}
                            options={categories}
                            placeholder="Категории"
                            noOptionsMessage={() => 'Нет категорий'}
                            onChange={(selected) => onChangeAdd('category', selected)}
                            value={values.category}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Значение*</label>
                    <div className="col-lg-9 col-xl-9">
                        <Input onChange={(e) => onChangeAdd('value', +e.target.value)} type="number" disableGroup={true} value={values.value}/>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Процент</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch nomargin={true} onChange={(value) => onChangeAdd('persent', +value)} checked={!!values.persent}/>
                    </div>
                </div>
            </>
        );
    }, [categories, loadingGoods, onChangeAdd, values.category, values.persent, values.value]);

    const variantOrderBlock = useMemo(() => {
        return (
            <>
                 <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Скидка*</label>
                    <div className="col-lg-9 col-xl-9">
                        <Input onChange={(e) => onChangeAdd('value', +e.target.value)} type="number" disableGroup={true} value={values.value}/>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Процент</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch nomargin={true} onChange={(value) => onChangeAdd('persent', +value)} checked={!!values.persent}/>
                    </div>
                </div>
            </>
        );
    }, [onChangeAdd, values.persent, values.value]);

    const variantBlock = useMemo(() => {
        return (
            <>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Тип</label>
                    <div className="col-lg-9 col-xl-9">
                        <select onChange={(e) => onChangeAdd('type', e.target.value)} value={values.type} className="form-control">
                            {
                                Object.keys(promotionType).map((key) => (
                                    <option key={key} value={key}>{promotionType[key]}</option>
                                ))
                            }
                        </select>
                    </div>
                </div>
                {values.type === 'goods' && variantGoods}
                {values.type === 'addGoods' && variantAddGoods}
                {values.type === 'category' && variantCategoryBlock}
                {values.type === 'order' && variantOrderBlock}
            </>
        );
    }, [onChangeAdd, values.type, variantAddGoods, variantCategoryBlock, variantGoods, variantOrderBlock]);

    const periodBlock = useMemo(() => {
        return (
            <>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Период действия</label>
                    <div className="col-lg-9 col-xl-9">
                        <div className="dateBlock">
                            <DateInput
                                placeholderText="Начало периода"
                                selected={values.startDate}
                                onChange={(date) => onChangeAdd('startDate', date)}
                            />
                            <div>-</div>
                            <DateInput
                                placeholderText="Конец периода"
                                selected={values.endDate}
                                onChange={(date) => onChangeAdd('endDate', date)}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Часы работы</label>
                    <div className="col-lg-9 col-xl-9">
                        <div className="dateBlock">
                            <DateInput
                                placeholderText="Начало периода"
                                showTimeSelectOnly
                                dateFormat="HH:mm"
                                selected={values.startTimeDate}
                                onChange={(date) => onChangeAdd('startTimeDate', date)}
                            />
                            <div>-</div>
                            <DateInput
                                placeholderText="Конец периода"
                                selected={values.endTimeDate}
                                showTimeSelectOnly
                                dateFormat="HH:mm"
                                onChange={(date) => onChangeAdd('endTimeDate', date)}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }, [onChangeAdd, values.endDate, values.endTimeDate, values.startDate, values.startTimeDate]);

    const oldOrderBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Предыдущий заказ (дней)</label>
                <div className="col-lg-9 col-xl-9">
                    <Input onChange={(e) => onChangeAdd('prevOrderDays', +e.target.value)} type="number" disableGroup={true} value={values.prevOrderDays}/>
                </div>
            </div>
        );
    }, [onChangeAdd, values.prevOrderDays]);

    const totalSumBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Сумма*</label>
                <div className="col-lg-9 col-xl-9">
                    <Input onChange={(e) => onChangeAdd('minPrice', +e.target.value)} type="number" disableGroup={true} value={values.minPrice}/>
                </div>
            </div>
        );
    }, [onChangeAdd, values.minPrice]);

    const bonusPointsBlock = useMemo(() => {
            return (
                <div className="form-group row">
                    <label className="col-xl-3 col-lg-3 col-form-label">Суммируется с бонусными баллами</label>
                    <div className="col-lg-9 col-xl-9">
                        <Switch nomargin={true} onChange={(value) => onChangeAdd('notCombinedBonusPoints', !value)} checked={values.notCombinedBonusPoints ? !values.notCombinedBonusPoints : true}/>
                    </div>
                </div>
            );
        }, [onChangeAdd, values.notCombinedBonusPoints]);
    
    const sourcesBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Доступно использование через:</label>
                <div className="col-lg-9 col-xl-9">
                    <Select
                        value={values.sources ? values.sources.split(' ') : undefined}
                        options={sourcesPromo}
                        getOptionLabel={(item) => `${sourcesTitlePromo[item]}`}
                        getOptionValue={(item) => item}
                        onChange={onChangeSource()}
                        isMulti
                        isClearable={false}
                        placeholder="Выберите источники..."
                        noOptionsMessage={() => 'Нет источников'}
                    />
                </div>
            </div>
        )
    }, [onChangeSource, values.sources]);

    const deliveryBlock = useMemo(() => {
        return (
            <div className="form-group row">
                <label className="col-xl-3 col-lg-3 col-form-label">Тип доставки</label>
                <div className="col-lg-9 col-xl-9">
                    <select onChange={(e) => onChangeAdd('delivery', e.target.value)} value={values.delivery} className="form-control">
                        {
                            Object.keys(deliveryType).map((key) => (
                                <option key={key} value={key}>{deliveryType[key]}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
        );
    }, [onChangeAdd, values.delivery]);

    const activeBlock = useMemo(() => {
        return (
            <div className="form-group form-group-last row">
                <label className="col-xl-3 col-lg-3 col-form-label">Включен</label>
                <div className="col-lg-9 col-xl-9">
                    <Switch nomargin={true} onChange={(value) => onChangeAdd('active', +value)} checked={!!values.active}/>
                </div>
            </div>
        );
    }, [onChangeAdd, values.active]);

    const content = useMemo(() => {
        return (
            <div className="kt-section__body">
                {namesCodeBlock}
                {cityBlock}
                <hr className="hrLine"/>
                {variantBlock}
                <hr className="hrLine"/>
                {periodBlock}
                <hr className="hrLine"/>
                {totalSumBlock}
                {bonusPointsBlock}
                {sourcesBlock}
                {deliveryBlock}
                {oldOrderBlock}
                {activeBlock}
            </div>
        );
    }, [activeBlock, cityBlock, deliveryBlock, namesCodeBlock, oldOrderBlock, periodBlock, totalSumBlock, variantBlock, bonusPointsBlock, sourcesBlock]);

    return (
        <div className="kt-grid  kt-wizard-v1 kt-wizard-v1--white" id="kt_apps_projects_add" data-ktwizard-state="first">
            <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
                <form className="kt-form">
                    <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
                        <div className="kt-heading kt-heading--md">Добавление акции</div>
                        <div className="kt-section kt-section--first">
                            <div className="kt-wizard-v1__form">
                                <div className="row">
                                    <div className="col-xl-12">
                                        {content}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {footer}
                </form>
            </div>
        </div>
    );
}

export default AddForm;